import React, { useState, useEffect } from "react";
import "./TitleBar.css";
import PersonIcon from "@mui/icons-material/Person";
import LanguageIcon from "@mui/icons-material/Language";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useNavigate } from "react-router-dom";
import Route_Logo from "../../images/logo_route.svg";

import Pro_icon from "../../images/navbar/profile/profile_icon.svg";
import Org_icon from "../../images/navbar/profile/org_icon.svg";
import Log_icon from "../../images/navbar/profile/logout_icon.svg";
import Apps_icon from "../../images/navbar/profile/app_icon.svg";
import Arrow_icon from "../../images/navbar/profile/arrow_right.svg";
import Veh_icon from "../../images/navbar/profile/veh_icon.svg";
import Sch_icon from "../../images/navbar/profile/school_icon.svg";
import Staff_icon from "../../images/navbar/profile/staff_icon.svg";

import { useUser } from "../../pages/login/UserContextPersistent";
import { useLocalizedTag } from "../../context/LocalizedTagContext";
import { useSettings } from "../../context/SettingsContext";
import LocalizationModal from "../common/LocalizationModal";
import axios from "axios";
import config from "../../config.json";
import authJson from "../../data/auth/auth.json";
import { getIsDemo } from "../../utils/helperFunction";
import Tooltip from "../common/Tooltip";

// const getIsDemo() = getIsDemo();
export default function TitleBar() {
  const navigate = useNavigate();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isLangDropdownVisible, setIsLangDropdownVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iconSize, setIconSize] = useState(window.innerWidth > 768 ? 40 : 30);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [isLoadingProfile, setIsLoadingProfile] = useState(false);
  const [showApplications, setShowApplications] = useState(false);
  const [selectedApp, setSelectedApp] = useState(() => {
    return localStorage.getItem("selectedApp") || null;
  });
  const { state, dispatch } = useUser();
  const { LocalizedTag, loading, language } = useLocalizedTag();
  const { settings, updateSettings } = useSettings();

  // Language options
  const languages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "es", name: "Español", flag: "🇪🇸" },
    { code: "fr", name: "Français", flag: "🇫🇷" },
    { code: "de", name: "Deutsch", flag: "🇩🇪" },
    { code: "zh", name: "中文", flag: "🇨🇳" },
    { code: "ar", name: "العربية", flag: "🇸🇦" },
    { code: "hi", name: "हिंदी", flag: "🇮🇳" },
    { code: "kn", name: "ಕನ್ನಡ", flag: "🇮🇳" },
    { code: "ud", name: "User Defined", flag: "🔄" },
  ];
  const fetchUserProfile = async () => {
    if (state?.user?.id) {
      setIsLoadingProfile(true);
      try {
        let response = await axios.get(
          `${config.baseURL}/user/${state.user.id}`,
          {
            withCredentials: true,
          },
        );

        if (response && response.data.user) {
          const user = response.data.user;
          if (user.Document && Array.isArray(user.Document)) {
            const profileDoc = user.Document.find(
              (doc) => doc.name === "profile" && doc.location,
            );
            if (profileDoc) {
              const imageUrl = `${config.baseURL}/upload/image?fileName=${profileDoc.location}`;
              setProfileImageUrl(imageUrl); // Just set the URL directly
            }
          }
        }
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setIsLoadingProfile(false);
      }
    }
  };
  // Fetch user profile image
  useEffect(() => {
    fetchUserProfile();
  }, [state?.user?.id]);

  // Monitor localStorage for selectedApp changes
  useEffect(() => {
    const handleStorageChange = () => {
      setSelectedApp(localStorage.getItem("selectedApp") || null);
    };

    window.addEventListener("storage", handleStorageChange);
    // Also check when component mounts in case app was changed in same tab
    const checkInterval = setInterval(() => {
      const storedApp = localStorage.getItem("selectedApp");
      if (storedApp !== selectedApp) {
        setSelectedApp(storedApp);
      }
    }, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(checkInterval);
    };
  }, [selectedApp]);

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
    if (isLangDropdownVisible) setIsLangDropdownVisible(false);
  };

  const toggleLangDropdown = () => {
    setIsLangDropdownVisible(!isLangDropdownVisible);
    if (isPopupVisible) setIsPopupVisible(false);
  };

  const handleLanguageChange = (langCode) => {
    updateSettings({ ...settings, defaultLanguage: langCode });
    setIsLangDropdownVisible(false);
  };

  const openLocalizationModal = () => {
    setIsLangDropdownVisible(false);
    setIsModalOpen(true);
  };

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;
      setIsMobile(newIsMobile);
      setIconSize(newIsMobile ? 30 : 40);
      if (newIsMobile) {
        setIsPopupVisible(false);
        setIsLangDropdownVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigateUser = () => {
    const id = state?.user?.id;
    navigate("/user/AddUser", { state: { id, from: "profile" } });
  };

  const handleNavigateOrg = () => {
    const id = state?.user?.id;
    navigate("/organization", { state: { id } });
  };

  const handleSwitchApplication = () => {
    setShowApplications(true);
  };

  const handleBackFromApplications = () => {
    setShowApplications(false);
  };

  const handleNavigateFleetManagement = () => {
    localStorage.setItem("selectedApp", "vehicleTrack");
    setIsPopupVisible(false);
    navigate("/dashboard");
  };

  const handleNavigateSchoolTracking = () => {
    localStorage.setItem("selectedApp", "schoolTrack");
    setIsPopupVisible(false);
    navigate("/school");
  };

  const handleNavigateStaffTracking = () => {
    localStorage.setItem("selectedApp", "staffTrack");
    setIsPopupVisible(false);
    window.location.href = "https://staff.routeeye.io";
  };

  const handleLogout = () => {
    localStorage.clear();
    dispatch({ type: "CLEAR_USER" });
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isPopupVisible && !event.target.closest(".dh-profile")) {
        setIsPopupVisible(false);
      }
      if (
        isLangDropdownVisible &&
        !event.target.closest(".language-selector")
      ) {
        setIsLangDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isPopupVisible, isLangDropdownVisible]);

  const getCurrentLanguage = () => {
    const lang = languages.find((l) => l.code === language);
    return lang || languages[0];
  };

  const orgId = JSON.parse(localStorage.getItem("userState"))?.organization?.id;
  const orgEmail = JSON.parse(localStorage.getItem("userState"))?.user?.email;
  const organizationType =
    JSON.parse(localStorage.getItem("userState"))?.organization
      ?.organizationType || [];

  // Get available apps based on organization type
  const getAvailableApps = () => {
    const apps = [];

    if (Array.isArray(organizationType)) {
      if (organizationType.includes("vehicleTrack")) {
        apps.push({
          id: "vehicleTrack",
          label: "Fleet Management System",
          icon: Veh_icon,
          handler: handleNavigateFleetManagement,
        });
      }
      if (organizationType.includes("schoolTrack")) {
        apps.push({
          id: "schoolTrack",
          label: "School Bus Tracking",
          icon: Sch_icon,
          handler: handleNavigateSchoolTracking,
        });
      }
      if (organizationType.includes("staffTrack")) {
        apps.push({
          id: "staffTrack",
          label: "Staff Tracking",
          icon: Staff_icon,
          handler: handleNavigateStaffTracking,
        });
      }
    }

    return apps;
  };

  const availableApps = getAvailableApps();

  const [isOrgTrue, setIsOrgTrue] = useState(() => {
    return orgId === 17 && orgEmail === "chandrakantha.dm@bialairport.com";
  });

  // Profile image component
  const ProfileImage = ({ size = iconSize, showBorder = true }) => {
    const imageStyle = {
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: "50%",
      objectFit: "cover",
      cursor: "pointer",
      border: showBorder ? "2px solid rgba(232, 234, 238, 1)" : "none",
    };

    const iconStyle = {
      fontSize: size,
      color: "rgba(24, 48, 89, 1)",
      background: "rgba(232, 234, 238, 1)",
      borderRadius: "50%",
      cursor: "pointer",
    };

    if (isLoadingProfile) {
      return (
        <div
          style={{
            ...imageStyle,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(232, 234, 238, 1)",
          }}
        >
          <div style={{ fontSize: "12px", color: "rgba(24, 48, 89, 1)" }}>
            ...
          </div>
        </div>
      );
    }

    return profileImageUrl ? (
      <img
        src={profileImageUrl}
        alt="Profile"
        style={imageStyle}
        onError={() => setProfileImageUrl(null)} // Fallback to icon on error
      />
    ) : (
      <PersonIcon style={iconStyle} />
    );
  };

  if (loading) {
    return <div></div>;
  }
  return (
    <div className={`title_container ${isMobile ? "mobile" : ""}`}>
      <div className="dh-main">
        <Tooltip
          text={
            isOrgTrue
              ? `BIAL Smart Shuttle`
              : selectedApp === "schoolTrack"
                ? `RouteEye for School`
                : `${getIsDemo() ? "Irisidea" : "RouteEye"}`
          }
          position="bottom"
        >
          <img
            src={`${
              state?.organization?.imageBlobUrl
                ? state?.organization?.imageBlobUrl
                : Route_Logo
            }`}
            alt="logo"
          />
        </Tooltip>
        <LocalizedTag
          tag="span"
          textKey={
            isOrgTrue
              ? `BIAL Smart Shuttle`
              : selectedApp === "schoolTrack"
                ? `RouteEye for School`
                : `${getIsDemo() ? "Irisidea" : "routeEye"}`
          }
          className="dh-title"
        />
      </div>
      <div className="dh-actions">
        {/* Language Selector */}
        <div className="language-selector">
          <div className="language-button" onClick={toggleLangDropdown}>
            <Tooltip text="Language" position="bottom">
              <LanguageIcon
                style={{
                  fontSize: iconSize * 0.8,
                  color: "rgba(24, 48, 89, 1)",
                  cursor: "pointer",
                  marginRight: "5px",
                }}
              />
            </Tooltip>
            <span className="current-language">
              {getCurrentLanguage().flag}
            </span>
            <svg
              width="12"
              height="6"
              viewBox="0 0 18 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginLeft: "5px" }}
            >
              <path
                d="M1 1L9 9L17 1"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {isLangDropdownVisible && (
            <div
              className="language-dropdown"
              style={{
                position: "fixed",
                zIndex: 1000,
              }}
            >
              {languages.map((lang) => (
                <div
                  key={lang.code}
                  className={`language-item ${
                    language === lang.code ? "active" : ""
                  }`}
                  onClick={() => handleLanguageChange(lang.code)}
                >
                  <span className="language-flag">{lang.flag}</span>
                  <span className="language-name">{lang.name}</span>
                </div>
              ))}
              <div className="language-divider"></div>
              <div
                className="language-item upload-item"
                onClick={openLocalizationModal}
              >
                <span className="language-flag">
                  <FileUploadIcon fontSize="small" />
                </span>
                <span className="language-name">Upload Translations</span>
              </div>
            </div>
          )}
        </div>

        {/* Profile Section */}
        <div className="dh-profile">
          <div className="dh-image" onClick={togglePopup}>
            <Tooltip text="Profile" position="bottom">
              <ProfileImage />
            </Tooltip>
          </div>

          {isPopupVisible && (
            <div className="profile-popup">
              {!showApplications ? (
                <>
                  <div className="popup-header">
                    <ProfileImage size={48} showBorder={false} />
                    <div className="profile-info">
                      <LocalizedTag
                        tag="div"
                        text={state?.user?.name || "userName"}
                        className="profile-name"
                      />
                      <LocalizedTag
                        tag="div"
                        text={state?.user?.role || "userRole"}
                        className="profile-username"
                      />
                    </div>
                  </div>
                  <div className="popup-menu">
                    <div className="menu-item" onClick={handleNavigateUser}>
                      <img src={Pro_icon} alt="Profile" />
                      <LocalizedTag tag="span" textKey="myProfile" />
                    </div>
                    <div className="menu-item" onClick={handleNavigateOrg}>
                      <img src={Org_icon} alt="Organization" />
                      <LocalizedTag tag="span" textKey="myOrganization" />
                    </div>
                    {availableApps.length > 1 && (
                      <div
                        className="menu-item"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "10px",
                        }}
                        onClick={handleSwitchApplication}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <img src={Apps_icon} alt="Applications" />
                          <LocalizedTag
                            tag="span"
                            textKey="switchApplication"
                          />
                        </div>
                        <img src={Arrow_icon} alt="Arrow" />
                      </div>
                    )}
                    <div className="menu-item" onClick={handleLogout}>
                      <img src={Log_icon} alt="Logout" />
                      <LocalizedTag tag="span" textKey="logout" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="popup-header"
                    style={{
                      paddingBottom: "10px",
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <button
                      onClick={handleBackFromApplications}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "16px",
                        padding: "0",
                        color: "#20A8E0",
                      }}
                    >
                      ← Back
                    </button>
                  </div>
                  <div className="popup-menu">
                    {availableApps.map((app) => (
                      <div
                        key={app.id}
                        className="menu-item"
                        onClick={app.handler}
                      >
                        <img
                          src={app.icon}
                          alt={app.label}
                          className="app-icon"
                        />
                        <LocalizedTag tag="span" text={app.label} />
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}

          <div style={{ cursor: "pointer" }} onClick={togglePopup}>
            <svg
              width="18"
              height="10"
              viewBox="0 0 18 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L9 9L17 1"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* Localization Modal */}
      <LocalizationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
}
